module.exports = __webpack_public_path__ + "assets/img/mecha-btn-56dd757e.png";